import { UploadImagesAPI } from '../../services/FileUpload/FileUploadService'

export const uploadImage = async (payload, customSuccessMsg, customErrorMsg) => {
    try {
        const response = await UploadImagesAPI(payload);
        if (!response || !response.isSuccess) {
            console.log('response?.message', response?.message || 'Failed to save Area');
            window.showSnackbar({
                message: customErrorMsg || `Failed to upload file`,
                variant: 'error'
            });
        } else {
            //   window.showSnackbar({
            //     message: customSuccessMsg || `Area saved successfully`,
            //     variant: 'success'
            //   });
            return response;
        }
        return null;
    } catch (err) {
        const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save Area');
        window.showSnackbar({
            message: errorMessage,
            variant: 'error'
        });
        console.log('Failed to save Area:', err);
        return { success: false, message: errorMessage };
    }
};